module.exports = __webpack_public_path__ + "image/banner_news_1_text_mobile_61e47.png";